import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Store } from '@ngxs/store';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';

@Injectable({
  providedIn: 'root'
})
export class CurriculumService {
  private _isOpen = false;
  private _isLoading = false;
  private _loaded = false;

  private classroom: ClassroomStateModel;

  public onDataLoad: (result: any) => void;

  constructor(
    private http: HttpClient,
    private store: Store,
  ) {
    this.listenStoreChanges();
  }

  public open(): void {
    this._isLoading = true;
    this._isOpen = true;
    this.http.get(`${this.classroom.vcrURL}/curriculum/topics`).subscribe((result: any) => {
      this._loaded = true;
      this._isLoading = false;
      if (this.onDataLoad) {
        this.onDataLoad(result);
      }
    });
  }

  public close(): void {
    this._isOpen = false;
  }

  public get isOpen(): boolean {
    return this._isOpen;
  }

  public get isLoading(): boolean {
    return this._isLoading;
  }

  private listenStoreChanges(): void {
    this.store.select(ClassroomState).subscribe((classroom: ClassroomStateModel) => {
      this.classroom = classroom;
    });
  }
}
